// extracted by mini-css-extract-plugin
export default {"diagram-tag":"DiagramTag_diagram-tag__8J5Yq","tag-name":"DiagramTag_tag-name__worRo"};